<template>
  <div v-if="isLoading" class="isLoadingDiv">
    <ProgressSpinner />
  </div>
  <div v-else>
    <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
    <div class="p-grid">
      <div class="p-col-12 paddedCol p-mt-5 p-text-left">
        <h3 class="title is-1 p-mt-3" style="display: inline">{{ $t("Schedule.schedules") }}</h3>
        <Button
          style="float: right"
          @click="goRouter('schedules/new')"
          class="p-button-lg"
          :label="this.$t('Button.create_schedule')"
        />
        <Button
          style="float: right; margin-right: 10px"
          @click="getData"
          class="p-button-lg p-button-outlined"
          :label="this.$t('Button.refresh')"
        />
      </div>
    </div>
    <div v-if="!schedules.length" class="p-text-center">
      {{ $t("no-schedules-created-yet") }}
    </div>
    <div
      v-for="d in schedules"
      :key="d.id"
      :id="d.id"
      class="p-col-12 rounded paddedCol whiteBg p-my-3 cursorpointer expand"
    >
      <div style="position: relative">
        <canvas @click="goRouter(`/schedules/${d.id}`)" :id="'canvas-' + d.id"></canvas>

        <div class="p-grid p-text-left cursorpointer" @click="goRouter(`/schedules/${d.id}`)">
          <div class="p-col-12">
            <h3 class="title is-3">
              {{ d.name }}
            </h3>
            <span v-if="d.is_practice"> ⭐️&nbsp;Practice Schedule </span>
          </div>
          <div class="p-col-12">
            <strong> {{ $t("Division.divisions") }} </strong>
            <div>
              <span v-for="(x, i) in d.divisions" :key="x.id">
                <router-link :to="`/divisions/${x.id}`">{{ x.name }}</router-link>
                <span v-if="i < d.divisions.length - 1">, </span>
              </span>
            </div>
          </div>
          <div class="p-col-12">
            <strong> {{ $t("results") }} </strong>
            <div v-if="!d.finished">
              <img style="height: 2em; vertical-align: middle" :src="`${baseURL}/diamond.gif`" />
              {{ $t("scheduling-in-progress-this-will-automatically-update-upon-completion") }}
            </div>
            <div v-else-if="d.is_imported">
              {{ $t("imported-schedule") }}
            </div>
            <div v-else>
              <span v-if="d.errored">
                🔴 &nbsp;ERROR
              </span>
              <span v-if="d.cancelled">
                🔴 &nbsp;CANCELLED
              </span>
              <span v-else :style="successStyle(d)">{{ $t("successrate-d-success", [successRate(d)]) }} </span>
              <br />
              {{
                $t("d-scheduled-scheduled-d-unscheduled-unscheduled", [
                  d.scheduled_items.length,
                  d.unscheduled_items.length,
                ])
              }}
            </div>
          </div>
          <div class="p-col-12">
            <strong> {{ $t("created") }} </strong>
            <div>
              {{ new Date(d.created_at).toLocaleString() }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  // dddd
  data() {
    return {
      confetti: null,
      isLoading: true,
      value: 1,
      value2: 1,
      interval: null,
      intervalCount: 0,
      schedules: [],
    };
  },
  methods: {
    getData() {
      this.isLoading = true;
      console.log("Get data, current schedules", this.schedules);
      api
        .getSeasonSchedules(this.$store.getters.currentSeason.id)
        .then(response => {
          this.schedules = response.data.filter(s => !s.is_tournament);
          this.isLoading = false;
          console.log("Got initial schedules for " + this.$store.getters.currentSeason.id, this.schedules);
          if (this.interval) {
            clearInterval(this.interval);
          }
          this.interval = setInterval(() => {
            // console.log("Interval");
            var need = false;
            var needs = [];
            if (this.schedules) {
              this.schedules.forEach(s => {
                if (!s.finished) {
                  console.log("Schedule " + s.id + " not finished");
                  need = true;
                  needs.push(s.id);
                }
              });
            }
            if (need && this.intervalCount < 20 && window.location.pathname == "/schedules") {
              api
                .getSeasonSchedules(this.$store.getters.currentSeason.id)
                .then(response => {
                  console.log("Response", response);
                  response.data.forEach(s => {
                    if (s.finished && needs.includes(s.id)) {
                      this.schedules = response.data;
                      if (this.successRate(s) > 75 && !this.confetti) {
                        this.confetti = true;
                        var c = document.getElementById("canvas-" + s.id);
                        c.style.zIndex = 1;
                        this.$confetti.start({
                          canvasId: "canvas-" + s.id,
                          defaultSize: 1,
                          particlesPerFrame: 10,
                          defaultDropRate: 5,
                          windSpeedMax: 0,
                        });
                        setTimeout(() => {
                          this.$confetti.stop();
                          setTimeout(() => {
                            c.style.zIndex = -1;
                            this.confetti = false;
                          }, 1500);
                        }, 2000);
                      }
                    }
                  });
                  console.log("Needs: ", needs);
                })
                .catch(e => {
                  console.log("Error", e);
                });
              this.intervalCount++;
            } else {
              this.stopInterval();
            }
          }, 5000);
        })
        .catch(e => {});
    },
    stopInterval() {
      // console.log("Clear interval");
      clearInterval(this.interval);
    },
    successStyle(d) {
      var color = "black";
      var r = this.successRate(d);
      if (r == 100) {
        color = "green";
      } else if (r > 50) {
        color = "orange";
      } else if (r == 0) {
        color = "black";
      }
      return { color: color };
    },
    successRate(d) {
      return Math.ceil((100 * d.scheduled_items.length) / (d.scheduled_items.length + d.unscheduled_items.length));
    },
  },
  created() {},
  mounted() {
    window.analytics.page();
    setTimeout(() => {
      this.getData();
    }, 1000);
  },
};
</script>

<style scoped lang="scss">
canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: none;
  z-index: -1;
}
</style>
